import * as Types from '../../../generated/graphql.types';

import gql from 'graphql-tag';
import { CoursePreviewFragmentDoc, UserPreviewFragmentDoc } from '../../_shared/fragments.generated';
import * as Urql from 'urql';
import { graphql, ResponseResolver, GraphQLRequest, GraphQLContext } from 'msw'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type MyUserGroupQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MyUserGroupQuery = { __typename?: 'QueryRoot', myUserGroup: { __typename?: 'UserGroup', id: string, name: string, courses: Array<{ __typename?: 'Course', id: string, name: string, assetId: number, updatedAt: string, updatedBy: string, routeChangeAlert?: { __typename?: 'RouteChangeAlert', courseId: string, archiveFilePath: string, createdAt: string } | null }>, users: Array<{ __typename?: 'User', id: string, name: string }> }, appConfig: { __typename?: 'AppConfig', routeChangeAlert: boolean } };


export const MyUserGroupDocument = gql`
    query MyUserGroup {
  myUserGroup {
    id
    name
    courses {
      ...CoursePreview
    }
    users {
      ...UserPreview
    }
  }
  appConfig {
    routeChangeAlert
  }
}
    ${CoursePreviewFragmentDoc}
${UserPreviewFragmentDoc}`;

export function useMyUserGroupQuery(options?: Omit<Urql.UseQueryArgs<MyUserGroupQueryVariables>, 'query'>) {
  return Urql.useQuery<MyUserGroupQuery, MyUserGroupQueryVariables>({ query: MyUserGroupDocument, ...options });
};

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockMyUserGroupQuery((req, res, ctx) => {
 *   return res(
 *     ctx.data({ myUserGroup, appConfig })
 *   )
 * })
 */
export const mockMyUserGroupQuery = (resolver: ResponseResolver<GraphQLRequest<MyUserGroupQueryVariables>, GraphQLContext<MyUserGroupQuery>, any>) =>
  graphql.query<MyUserGroupQuery, MyUserGroupQueryVariables>(
    'MyUserGroup',
    resolver
  )
